import {BedarfsgemeinschaftDto} from '@wba/models/dto/bedarfsgemeinschaft-dto';
import {BgNummerListeDto} from '@wba/models/dto/bg-nummer-liste-dto';
import {ResponseBody} from '@wba/services/api/bedarfsgemeinschaft/response-body.interface';
import {Observable} from 'rxjs';


export abstract class BedarfsgemeinschaftService {
  abstract getBg(): Observable<BedarfsgemeinschaftDto>;

  abstract updateBg(bg: BedarfsgemeinschaftDto): Observable<BedarfsgemeinschaftDto>;

  abstract updateBgHatEinkommen(hatEinkommen: boolean): Observable<ResponseBody>;

  abstract deleteKdu(): Observable<any>;

  abstract updateBgHaushalt(bg: BedarfsgemeinschaftDto): Observable<BedarfsgemeinschaftDto>;

  abstract getBgNummer(): Observable<BgNummerListeDto[]>;

  abstract getExistBgNummer(bgNummer: string): Observable<any>;

  abstract getDiensstellennummer(bgNummer: string): Observable<string>;
}
